(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function loadFeaturedProducts() {
    const contentProdsEl = document.querySelector('.content-products');
    if (!contentProdsEl) return;

    const prodEls = contentProdsEl.querySelectorAll('[data-lazy-product-handle]');
    const ratioSetting = theme.settings.prod_card_image_ratio;
    let ratioValue = ratioSetting;

    if (ratioSetting === 'shortest') {
      ratioValue = 0;
    } else if (ratioSetting === 'tallest') {
      ratioValue = 99;
    }

    contentProdsEl.classList.add('is-loading');

    async function getProducts() {
      for (el of prodEls) {
        await fetch(`/products/${el.dataset.lazyProductHandle}/?section_id=product-item`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            const fetchedHTML = document.implementation.createHTMLDocument();
            fetchedHTML.documentElement.innerHTML = html;

            if (ratioSetting === 'shortest' || ratioSetting === 'tallest') {
              const imgMain = fetchedHTML.querySelector('.prod-image__main');
              
              if (imgMain) {
                const paddingTop = imgMain.style.paddingTop;
                const thisRatio = 1 / (Number(paddingTop.slice(0, -1)) / 100);

                if (ratioSetting === 'shortest') {
                  if (thisRatio > ratioValue) {
                    ratioValue = thisRatio;
                  }
                } else if (thisRatio < ratioValue) {
                  ratioValue = thisRatio;
                }
              }
            }

            el.replaceWith(fetchedHTML.querySelector('.card'));
          })
          .catch(() => {
            el.remove();
          });
      }

      contentProdsEl.querySelectorAll('.prod-image__main').forEach((el) => {
        el.style.paddingTop = `${(1 / ratioValue) * 100}%`;
      });

      contentProdsEl.classList.remove('is-loading');
    }

    getProducts();
  }

  document.addEventListener('DOMContentLoaded', loadFeaturedProducts);
  document.addEventListener('shopify:section:load', loadFeaturedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opkl-recommendations"] && !Shopify.designMode) return;
  try {
    
function loadProductRecommendations() {
 const sprSection = document.querySelector('.product-recommendations');
 const { limit, url } = sprSection.dataset;

 fetch(sprSection.dataset.url)
   .then((response) => {
     if (!response.ok) { throw response };
     return response.text();
   })
   .then((html) => {
     const div = document.createElement('div');
     const colClass = new Map([['2', 'half'], ['3', 'third'], ['4', 'quarter'], ['5', 'fifth']]);

     div.innerHTML = html;
     div.querySelectorAll('.card').forEach((el) => {
       el.classList.remove('half', 'third', 'quarter', 'fifth');
       el.classList.add(colClass.get(limit));
     });
     sprSection.parentElement.innerHTML = div.querySelector('.product-recommendations').innerHTML;

     window.theme.initAnimateOnScroll();
     const observ = lozad();
     observ.observe();
   })
   .catch((error) => {
     console.log(error);
   });
};

document.addEventListener('shopify:section:load', (e) => {
 const sectionEl = document.querySelector('.product-recommendations');

 if (sectionEl && sectionEl.dataset.sectionId === e.detail.sectionId) {
   loadProductRecommendations();
 }
});

document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function loadProductRecommendations() {
    const sprSection = document.querySelector('.product-recommendations');
    const { limit, url } = sprSection.dataset;

    fetch(sprSection.dataset.url)
      .then((response) => {
        if (!response.ok) { throw response };
        return response.text();
      })
      .then((html) => {
        const div = document.createElement('div');
        const colClass = new Map([['2', 'half'], ['3', 'third'], ['4', 'quarter'], ['5', 'fifth']]);

        div.innerHTML = html;
        div.querySelectorAll('.card').forEach((el) => {
          el.classList.remove('half', 'third', 'quarter', 'fifth');
          el.classList.add(colClass.get(limit));
        });
        sprSection.parentElement.innerHTML = div.querySelector('.product-recommendations').innerHTML;

        window.theme.initAnimateOnScroll();
        const observ = lozad();
        observ.observe();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  document.addEventListener('shopify:section:load', (e) => {
    const sectionEl = document.querySelector('.product-recommendations');

    if (sectionEl && sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
